export const productCardEvents = {
  cardInView: "product-list:card-in-view",
  cardClick: "product-list:card-click",
  quickViewOpened: "product-list:quick-view:opened",
  quickViewUpdated: "product-list:quick-view:updated",
  quickViewAddToBasket: "product-list:quick-view:add-to-basket",
  removeProduct: "product-list:remove-product",
  increaseQuantity: "product-list:increase-quantity",
  decreaseQuantity: "product-list:decrease-quantity",
  addToWishlist: "product-list:add-to-wishlist",
  ctaAddToBasket: "product-list:cta:add-to-basket",
  ctaEmailMe: "product-list:cta:email-me",
  ctaMoreInformation: "product-list:cta:more-information",
  ctaViewOptions: "product-list:cta:view-options",
  ctaInStoreOnly: "product-list:cta:in-store-only",
  ctaOutOfStock: "product-list:cta:out-of-stock",
  ctaWellBeInTouch: "product-list:cta:well-be-in-touch",
  ctaGoToBasket: "product-list:cta:go-to-basket",
  ctaViewRange: "product-list:cta:view-range",
} as const;

export type EventName =
  (typeof productCardEvents)[keyof typeof productCardEvents];
